import GroupChangeHistory from "./GroupChangeHistory";
export default GroupChangeHistory;
